const OverStay = {

    // PAGE HEADER
    "over_stay": "Over Stay",

    // FIELDS
    "search": "Search",

    // ENTRY TYPES
    "entry_type_visitor": "Visitor",
    "entry_type_delivery": "Delivery",
    "entry_type_service_provider": "Service Provider / Staff",
    "entry_type_resident": "Resident",
    "entry_type_staff": "Staff",

    // TABLE HEADERS
    "table_no": "NO",
    "table_name": "NAME",
    "table_entry_type": "ENTRY TYPE",
    "table_vehicle": "VEHICLE",
    "table_premise": "PREMISE",
    "table_unit": "UNIT",
    "table_gate": "GATE",
    "table_entry_date_time": "ENTRY D&T",
    "table_allowed_duration": "ALLOWED DURATION",
    "table_over_stay_duration": "OVER STAY DURATION",
    "table_status": "STATUS",

    // ACTIONS
    "reminder": "Reminder",
    "confirm_reminder_title": "Send Reminder?",
    "confirm_reminder_text": "Are you sure you want to send an overstay reminder for this visitor?",
    "confirm_reminder_all_text": "Are you sure you want to send an overstay reminder for all visitors?",
    "success_reminder": "Reminder sent successfully",

}

export default OverStay;